import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { filter, finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { IPC_CHANNEL } from '../electron.constants';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonConfirmDialogComponent } from '../../common-dialog/common-confirm-dialog.component';
import { platform } from '../../../platform/platform';
import { PLATFORM } from '../../app.constants';
import { NetworkStatusService } from '../../_services/network-status.service';
import { SpinnerService } from '../../_services/spinner.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class IplexGConnectModeService {

  constructor(
    private translate: TranslateService,
    private electronService: ElectronService,
    private zone: NgZone,
    private desktopNetworkStatus: NetworkStatusService,
    private dialog: MatDialog,
    private oscSpinnerService: SpinnerService
  ) {
  }

  private isHttpsMode = new BehaviorSubject<boolean>(false);
  private _isWebDAVConnectMode$ = new BehaviorSubject<boolean>(false);

  private confirmDialogRef: MatDialogRef<CommonConfirmDialogComponent, any> = undefined;

  public get isHttpsConnectMode() {
    return this.isHttpsMode.getValue();
  }

  public get isWebDAVConnectMode() {
    return this._isWebDAVConnectMode$.getValue();
  }

  public isHttpsModeObserver() {
    return this.isHttpsMode.asObservable()
      .pipe(filter(val => val !== null || val !== undefined));
  }

  public get isWevDAVModeObserver() {
    return this.isHttpsMode.asObservable()
      .pipe(filter(val => val !== null || val !== undefined));
  }

  private get isOffline() {
    return this.desktopNetworkStatus.isOffline;
  }

  public setHttpsMode(isIplexGConnectMode: boolean) {
    this.isHttpsMode.next(isIplexGConnectMode);
    return this.isHttpsConnectMode;
  }

  public setWebDAVMode(isIplexGConnectMode: boolean) {
    this._isWebDAVConnectMode$.next(isIplexGConnectMode);
    return this.isWebDAVConnectMode;
  }

  public setSubscriptions() {
    if (this.isOffline) {
      this.electronService.offEvent(IPC_CHANNEL.WEB_DAV.STREAM_ERROR, (_event, reply) => {
        this.notifyLinkErrors(true);
      });

      this.electronService.onEvent(IPC_CHANNEL.WEB_DAV.STREAM_ERROR, (_event, reply) => {
        this.notifyLinkErrors(true);
      });
    }
  }

  public notifyLinkErrors(isWebDAV: boolean) {
    if (!this.isOffline) { return; }

    this.zone.run(() => {
      if (this.isWebDAVConnectMode) {
        of(this.electronService.sendSyncCommand(IPC_CHANNEL.WEB_DAV.SAVE_CANCEL))
          .subscribe(_ => {});
        this.setWebDAVMode(false);
      }

      if (this.isHttpsConnectMode) {
        this.setHttpsMode(false);
        const firstMessage = isWebDAV
          ? this.translate.instant('iplexGLink.transferError1')
          : this.translate.instant('iplexGLink.linkError1');
        const secondMessage = isWebDAV
          ? this.translate.instant('iplexGLink.transferError2')
          : this.translate.instant('iplexGLink.linkError2');

        if (this.confirmDialogRef === undefined) {
          this.oscSpinnerService.hide(true);
          this.confirmDialogRef = this.dialog.open(CommonConfirmDialogComponent, {
            disableClose: true,
            data: {
              firstMessage: firstMessage,
              secondMessage: secondMessage,
              dialogType: 'information'
            }
          });

          this.confirmDialogRef.afterClosed()
            .pipe(finalize(() => this.confirmDialogRef = undefined))
            .subscribe(() => {});
        }
      }
    });
  }
}
